import { createAsyncThunk } from '@reduxjs/toolkit'
import GameContext from './game-context-model'
import {
  delete_gameContext,
  load_gameContexts,
  store_gameContext,
} from './gameContext-service'

export const LoadGameContextsAsync = createAsyncThunk<any, any>(
  'composer/load/gameContext',
  async (params: { uid: string }) => {
    return await load_gameContexts(params)
  },
)

export const CreateGameContextAsync = createAsyncThunk<any, any>(
  'composer/create/gameContext',
  async (params: GameContext) => {
    return await store_gameContext(params)
  },
)

export const DeleteGameContextAsync = createAsyncThunk<any, any>(
  'composer/delete/gameContext',
  async (params) => {
    return await delete_gameContext(params)
  },
)
